
interface AddressSuggestion {
  place_id: string;
  description: string;
  structured_formatting: {
    main_text: string;
    secondary_text: string;
  };
}

export const LocationService = {
  /**
   * Get address suggestions from Google Maps Places API
   * @param query Search query for address
   * @param lat Optional latitude for location biasing
   * @param lng Optional longitude for location biasing
   * @returns List of address suggestions
   */
  getAddressSuggestions: async (
    query: string, 
    lat?: number, 
    lng?: number
  ): Promise<AddressSuggestion[]> => {
    if (query.length < 3) return [];
    
    try {
      // Construct query params
      const params = new URLSearchParams({
        query
      });
      
      if (lat !== undefined && lng !== undefined) {
        params.append('lat', lat.toString());
        params.append('lng', lng.toString());
      }
      
      const response = await fetch(`/api/suggestions?${params.toString()}`);
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Failed to get address suggestions');
      }
      
      return await response.json();
    } catch (error: any) {
      console.error('Error fetching address suggestions:', error);
      throw error;
    }
  },
  
  /**
   * Geocode an address to get latitude and longitude
   * @param address Full address to geocode
   * @returns Latitude, longitude and formatted address
   */
  geocodeAddress: async (address: string): Promise<{
    lat: number;
    lng: number;
    formatted_address: string;
  }> => {
    try {
      const response = await fetch(`/api/geocode?address=${encodeURIComponent(address)}`);
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Failed to geocode address');
      }
      
      return await response.json();
    } catch (error: any) {
      console.error('Error geocoding address:', error);
      throw error;
    }
  }
};

export default LocationService;
